// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--rZ6NN","body":"body--HVj5m","main":"main--Q6Iu7","clearPadding":"clearPadding--fTm1h","fullWidth":"fullWidth--Lg17A","side":"side--i6imN"};